import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export const useCrUserId = () => {
  const userContext = useContext(AuthContext);
  if (!userContext) throw new Error('useCrUserId must be used within a AuthProvider');

  const { user } = userContext;

  return user.user;
};
